
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import StockAdjusetmentModule from "@/store/modules/barcodeSystem/stockAdjustment";
import ModalMixin from "./mixin";
import StockAdjustmentHeader from "@/components/barcodeSystem/stockAdjustment/StockAdjustmentHeader.vue";
import StockAdjustmentDetailTable from "@/components/barcodeSystem/stockAdjustment/StockAdjustmentDetailTable.vue";
import notifications from "@/lib/notifications";
import { EditStockAdjustment, EditStockAdjustmentDetail } from "@/models/api/barcodeSystem/stockAdjustments/edit";

const stockAdjustmentModuleState = getModule(StockAdjusetmentModule);

@Component({
  name: modals.stockAdjustmentViewModal,
  components: {
    StockAdjustmentHeader,
    StockAdjustmentDetailTable
  }
})
export default class StockAdjustmentViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  detailsLoading: boolean = false;
  editStockAdjustment: EditStockAdjustment | null = null;

  async load() {
    this.loadingComplete = false;
    this.show();

    if(this.selectedItem) {
      await stockAdjustmentModuleState.loadStockAdjustment(this.selectedItem.id);
      await stockAdjustmentModuleState.loadStockAdjustmentDetails(this.selectedItem.id);
    
      this.editStockAdjustment = new EditStockAdjustment(
        stockAdjustmentModuleState.currentStockAdjustment, 
        stockAdjustmentModuleState.currentStockAdjustmentDetails);

    } else {
      this.editStockAdjustment = new EditStockAdjustment(null, null);
    }

    this.loadingComplete = true;
  }

  get editStockAdjustmentDetails() : Array<EditStockAdjustmentDetail> {
    return this.editStockAdjustment ? this.editStockAdjustment.details : null;
  }

  async reloadOrder(){
    this.loadingComplete = false;
    try {
      await stockAdjustmentModuleState.reloadStockAdjustment();
      await stockAdjustmentModuleState.loadStockAdjustmentDetails(this.editStockAdjustment.id);
      
      this.editStockAdjustment = new EditStockAdjustment(
        stockAdjustmentModuleState.currentStockAdjustment, 
        stockAdjustmentModuleState.currentStockAdjustmentDetails);
    } catch (ex) {
      notifications.error("Failed to load stock adjustment", "Failed to load stock adjustment.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  reset() {
    this.loadingComplete = false;
  }
}
